import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './activity-review.reducer';

export const ActivityReviewDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const activityReviewEntity = useAppSelector(state => state.activityReview.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="activityReviewDetailsHeading">
          <Translate contentKey="activitiesApp.activityReview.detail.title">ActivityReview</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{activityReviewEntity.id}</dd>
          <dt>
            <span id="reviewDate">
              <Translate contentKey="activitiesApp.activityReview.reviewDate">Review Date</Translate>
            </span>
          </dt>
          <dd>
            {activityReviewEntity.reviewDate ? (
              <TextFormat value={activityReviewEntity.reviewDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="noOfStars">
              <Translate contentKey="activitiesApp.activityReview.noOfStars">No Of Stars</Translate>
            </span>
          </dt>
          <dd>{activityReviewEntity.noOfStars}</dd>
          <dt>
            <span id="reviewdUser">
              <Translate contentKey="activitiesApp.activityReview.reviewdUser">Reviewd User</Translate>
            </span>
          </dt>
          <dd>{activityReviewEntity.reviewdUser}</dd>
          <dt>
            <span id="commnet">
              <Translate contentKey="activitiesApp.activityReview.commnet">Commnet</Translate>
            </span>
          </dt>
          <dd>{activityReviewEntity.commnet}</dd>
          <dt>
            <span id="childFriendly">
              <Translate contentKey="activitiesApp.activity.approved">Approved</Translate>
            </span>
          </dt>
          <dd>{activityReviewEntity.approved ? 'true' : 'false'}</dd>
          <dt>
            <span id="bookingId">
              <Translate contentKey="activitiesApp.activityReview.bookingId">Booking Id</Translate>
            </span>
          </dt>
          <dd>{activityReviewEntity.bookingId}</dd>
          <dt>
            <Translate contentKey="activitiesApp.activityReview.activity">Activity</Translate>
          </dt>
          <dd>{activityReviewEntity.activity ? activityReviewEntity.activity.name : ''}</dd>
          <dt>
            <span id="recommend">
              <Translate contentKey="activitiesApp.activityReview.recommend">Recommend</Translate>
            </span>
          </dt>
          <dd>{activityReviewEntity.recommend ? 'true' : 'false'}</dd>
        </dl>
        <Button tag={Link} to="/activity-review" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/activity-review/${activityReviewEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ActivityReviewDetail;
